// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".website--code[data-v-13e16296]{\n  margin:1.6rem auto;\n  max-width:70%\n}", "",{"version":3,"sources":["/app/app/javascript/dashboard/routes/dashboard/settings/teams/FinishSetup.vue"],"names":[],"mappings":"AAiCA;EACE,kBAAA;EACA;AAAA","file":"FinishSetup.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@import '~dashboard/assets/scss/variables';\n\n.website--code {\n  margin: $space-normal auto;\n  max-width: 70%;\n}\n"]}]);
// Exports
module.exports = exports;
